<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">会员管理<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <label style="margin-left: 16px;">性别筛选</label>
              <el-select v-model="sex" placeholder="Select" class="select-item">
                <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="充值时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>


            <div class="content-input-item">
              <DatePickerRange_7 labelWidth="6em" title="上次消费时间" @date="getPreBookTime($event)" @check="getPreBookCheck($event)" :isChecked="isPreBookChecked"/>
            </div>

            <div class="content-input-item">
              <label>&nbsp;&nbsp;&nbsp;&nbsp;总余额</label>
              <el-input v-model="totalBalanceMin" placeholder="最低余额"></el-input>
              <span style="margin: 0 4px">-</span>
              <el-input v-model="totalBalanceMax" placeholder="最高余额"></el-input>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="抵扣时间" @date="getDeductionTime($event)" @check="getDeductionCheck($event)" :isChecked="isDeductionChecked"/>
            </div>

            <div class="content-input-item">
              <!--              <label>会员搜索</label>-->
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap">有限制</span></el-checkbox>
            </div>




          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)">查询</ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam">重置</ElButtons>
            </div>
          </div>
        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
<!--            <SearchUidOrPhone style="margin-right: 16px;" @confirm="openDialog($event)"/>-->
            <ElButtons type="danger" icon="Wallet" @click="openDialog()">充值</ElButtons>
          </div>
          <div style="display: flex; align-items: center;">
            <el-upload
                action="—"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="upLoadCharge">
              <el-button v-loading="upChargeLoading" type="warning" style="margin-left: 16px;">导入充值信息Excel</el-button>
            </el-upload>
            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
          </div>

        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              @selection-change="selsChange"
              @header-click="selsAll"
              size="default"
              border
              @sort-change="sortChange"
          >
<!--            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
            <el-table-column property="" label="会员信息" v-if="checkColList.indexOf('会员信息') > -1" width="200">
              <template #default="scope">
                <UserInfo :userId="scope.row.id" show-pay-btn :row="scope.row" showList="name,sex,phone,shopName,uid" @confirm="getPage"/>
                <p v-if="scope.row.type == 1">类型：门店散客</p>
              </template>
            </el-table-column>
            <el-table-column property="payTime" label="最新充值时间" v-if="checkColList.indexOf('最新充值时间') > -1" sortable='custom' width="150">
              <template #default="scope">
                {{scope.row.userPerfect.payTime}}
              </template>
            </el-table-column>
<!--            <el-table-column property="" label="充值记录" v-if="checkColList.indexOf('充值记录') > -1" class-name="cursor" width="260">-->
<!--              <template #default="scope">-->
<!--                <RecordList :record-list="scope.row.walletPayDetailList" :type="1"/>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column property="deductionTime" label="最新抵扣时间" v-if="checkColList.indexOf('最新抵扣时间') > -1" sortable='custom' width="150">
              <template #default="scope">
                {{scope.row.userPerfect.deductionTime}}
              </template>
            </el-table-column>
<!--            <el-table-column property="" label="抵扣记录" v-if="checkColList.indexOf('抵扣记录') > -1" class-name="cursor" width="260">-->
<!--              <template #default="scope">-->
<!--                <RecordList :record-list="scope.row.walletDeductionDetailList" :type="2"/>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column property="" label="充值抵扣记录" v-if="checkColList.indexOf('充值抵扣记录') > -1" class-name="cursor" width="260">
              <template #default="scope">
                <RecordList :record-list="scope.row.walletDetailList" :type="1"/>
              </template>
            </el-table-column>
            <el-table-column property="paySum" label="充值总额" v-if="checkColList.indexOf('充值总额') > -1" class-name="cursor" width="140" sortable='custom'>
              <template #default="scope">
                <p style="color: #3a8ee6">{{ scope.row.userWallet.payAllSum }}</p>
                <p>充值金额：{{scope.row.userWallet.paySum}}</p>
                <p>赠送金额：{{scope.row.userWallet.payGiveSum}}</p>
              </template>
            </el-table-column>
            <el-table-column property="dedSum" label="抵扣总额" v-if="checkColList.indexOf('抵扣总额') > -1" class-name="cursor" width="120" sortable='custom'>
              <template #default="scope">
                <span style="color: #3a8ee6">{{ scope.row.userWallet.dedSum }}</span>
              </template>
            </el-table-column>
            <el-table-column property="balanceSum" label="总余额" v-if="checkColList.indexOf('总余额') > -1" class-name="cursor" width="140" sortable='custom'>
              <template #default="scope">
                <span style="color: #3a8ee6">{{ scope.row.userWallet.balanceAllSum}}</span>
                <p>充值余额：{{scope.row.userWallet.balanceSum}}</p>
                <p>赠送余额：{{scope.row.userWallet.balanceGiveSum}}</p>
              </template>
            </el-table-column>
            <el-table-column property="medicalBenefit" label="医疗金余额" v-if="checkColList.indexOf('医疗金余额') > -1" class-name="cursor" width="140">
              <template #default="scope">
                <p style="color: #3a8ee6">{{ scope.row.userWallet.medicalBenefit}}</p>
                <p v-if="scope.row.userWallet.disableMedicalBenefit > 0">已过期：{{ scope.row.userWallet.disableMedicalBenefit}}</p>
              </template>
            </el-table-column>
            <el-table-column property="" label="消费单" v-if="checkColList.indexOf('消费单') > -1" class-name="cursor" width="260">
              <template #default="scope">
                <ConsumeList :payList="scope.row.userConsumeList" />
              </template>
            </el-table-column>
            <el-table-column property="preBookTime" label="上次消费时间" v-if="checkColList.indexOf('上次消费时间') > -1" sortable='custom' width="150">
              <template #default="scope">
                {{scope.row.userPerfect.preBookTime}}
              </template>
            </el-table-column>
            <el-table-column property="" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor" width="260">
              <template #default="scope">
                <!--                <UserRemark :userRemarkList="scope.row.userRemarkList" />-->
                <div v-for="(item,index) in scope.row.userRemarkList" :key="index" style="margin: 8px 0; font-size: 14px; display: flex; flex-wrap: wrap;">
                  <span style="margin-right: 8px;">{{item.createTime}}</span>
                  <el-tag size="small" style="margin-right: 8px; ">{{item.adminName}}</el-tag>
                  <span style="margin-right: 8px;" v-high-light="{value: item.content}">{{item.content}}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getFormData, imgPostFormData, postFormData} from "@/api/api";
import {getMemberPageList, updateShopProjectState, uploadChargeExcel} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserRemarkDialog from "@/components/Remark/UserRemarkDialog";
import UserInfo from "@/components/User/userInfo";
import DatePickerRange from "@/components/DatePickerRange";
import RecordList from "@/views/user/components/RecordList";
import SearchUidOrPhone from "@/components/SearchUidOrPhone";
import SearchInfoDialog from "@/views/user/components/SearchInfoDialog";
import RecordListDialog from "@/views/user/components/RecordListDialog";
import WalletDialog from "@/views/user/components/WalletDialog";
import { add , Number_SubAll} from "@/assets/shared/util";
import payListDialog from "@/views/user/components/payListDialog";
import DeductionListDialog from "@/views/user/components/DeductionListDialog";
import unLock from "@/layout/components/unLock";
import DatePickerRange_7 from "@/components/DatePickerRange_7";
import ConsumeList from "@/views/user/components/ConsumeList";
import ConsumeListDialog from "@/views/user/components/ConsumeListDialog";
import medicalListDialog from "@/views/user/components/medical/medicalListDialog";
import PayDeductionListDialog from "@/views/user/components/PayDeductionListDialog";

export default {
  name: "UserMember",
  components: {BtnGroup, SearchComponents, SearchUidOrPhone, UserInfo, DatePickerRange, RecordList, unLock, DatePickerRange_7, ConsumeList },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
        {label: '未知', value: 0}
      ],
      sex: -1,


      //刷新组
      colList: ['会员信息', '最新充值时间', '最新抵扣时间', '充值抵扣记录', '充值总额', '抵扣总额', '总余额', '医疗金余额', '消费单', '上次消费时间', '备注'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '主人', value : 2},
        {label : '宠物昵称', value : 3},
        {label : '客户备注', value : 4},
        {label : '主人ID', value : 5},
      ],
      searchType: 1,
      searchValue: '',
      limitState: true,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //抵扣时间
      startDeductionTime: '',
      endDeductionTime: '',
      isDeductionChecked: true,

      //时间
      startPreBookTime: '',
      endPreBookTime: '',
      isPreBookChecked: true,

      totalBalanceMin: '',
      totalBalanceMax: '',

      idArray: [],
      sort: 2,

      upChargeLoading: false,


    }
  },
  methods: {

    upLoadCharge(file) {
      // console.log(file)
      this.upChargeLoading = true
      let param = new FormData();
      param.append('file', file.raw);
      imgPostFormData(uploadChargeExcel, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.getPage(true)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.upChargeLoading = false
      }).catch(()=>{
        this.upChargeLoading = false
      })
    },

    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.limitState = true;
      this.isPreBookChecked = true;
      this.isDeductionChecked = true;
      this.sex = -1;
      this.shopId = 0;
      this.searchValue = '';
      this.totalBalanceMin = '';
      this.totalBalanceMax = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getDeductionTime(val) {
      this.startDeductionTime = val[0];
      this.endDeductionTime = val[1];
      // console.log(val)
    },
    getDeductionCheck(val) {
      this.isDeductionChecked = val
    },

    getPreBookTime(val) {
      this.startPreBookTime = val[0];
      this.endPreBookTime = val[1];
      // console.log(val)
    },
    getPreBookCheck(val) {
      this.isPreBookChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    //排序
    sortChange(column) {
      if(column.prop == 'payTime') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'deductionTime') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      } else if(column.prop == 'paySum') {
        if(column.order == 'descending') {
          this.sort = 5;
        } else if(column.order == 'ascending') {
          this.sort = 6;
        }
      } else if(column.prop == 'dedSum') {
        if(column.order == 'descending') {
          this.sort = 7;
        } else if(column.order == 'ascending') {
          this.sort = 8;
        }
      } else if(column.prop == 'balanceSum') {
        if(column.order == 'descending') {
          this.sort = 9;
        } else if(column.order == 'ascending') {
          this.sort = 10;
        }
      }else if(column.prop == 'preBookTime') {
        if(column.order == 'descending') {
          this.sort = 11;
        } else if(column.order == 'ascending') {
          this.sort = 12;
        }
      }
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sort'] = this.sort;
      param['sex'] = this.sex;
      param['shopId'] = this.shopId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['startDeductionTime'] = this.startDeductionTime;
      param['endDeductionTime'] = this.endDeductionTime;
      param['startPreBookTime'] = this.startPreBookTime;
      param['endPreBookTime'] = this.endPreBookTime;
      param['totalBalanceMin'] = this.totalBalanceMin;
      param['totalBalanceMax'] = this.totalBalanceMax;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getMemberPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          // this.pageDataList.sort(this.compare)
          this.pageDataList.map(item => {
            item.userWallet.payAllSum = 0
            item.userWallet.paySum = 0
            item.userWallet.payGiveSum = 0
            item.userWallet.dedSum = 0
            item.userWallet.balanceAllSum = 0
            item.userWallet.balanceSum = 0
            item.userWallet.balanceGiveSum = 0
            item.userWallet.paySum = add([item.userWallet.paySumOne, item.userWallet.paySumTwo, item.userWallet.paySumThree, item.userWallet.paySumFour])
            item.userWallet.payGiveSum = add([item.userWallet.paySumOneGive, item.userWallet.paySumTwoGive, item.userWallet.paySumThreeGive, item.userWallet.paySumFourGive])
            item.userWallet.payAllSum = add([item.userWallet.paySum, item.userWallet.payGiveSum])
            item.userWallet.balanceSum = add([item.userWallet.balanceOne, item.userWallet.balanceTwo, item.userWallet.balanceThree, item.userWallet.balanceFour])
            item.userWallet.balanceGiveSum = add([item.userWallet.balanceOneGive, item.userWallet.balanceTwoGive, item.userWallet.balanceThreeGive, item.userWallet.balanceFourGive])
            item.userWallet.balanceAllSum = add([item.userWallet.balanceSum, item.userWallet.balanceGiveSum])
            item.userWallet.dedSum = Number_SubAll(item.userWallet.payAllSum, item.userWallet.balanceAllSum)
          })
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    compare(a, b) {
      const bandA = a.shopId;
      const bandB = b.shopId;

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    // editUserDialog(idx, row) {
    //   let _title = '';
    //   let userForm = {}
    //   if (idx > -1) {
    //     _title = '修改资料'
    //     userForm = Object.assign({}, row);
    //     // console.log(userForm)
    //   }else {
    //     _title = '创建新客'
    //     // console.log(userForm)
    //   }
    //   Dialog.open({
    //     title: _title,
    //     component: UserDialog,
    //     data: {
    //       userForm: userForm,
    //       ids: idx,
    //       width: '600px',
    //     },
    //     confirm: (result) => {
    //       this.getPage()
    //     }
    //   })
    // },


    // updateState(row, state) {
    //   row.updateLoading = true;
    //   let param = {};
    //   param['id'] = row.id;
    //   param['state'] = state;
    //   postFormData(updateShopProjectState, param).then((data)=>{
    //     let {code, msg} = data;
    //     if (code == 200) {
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'success'
    //       })
    //       row.state = state
    //     }else {
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'warning'
    //       })
    //     }
    //     row.updateLoading = false;
    //   }).catch(()=> {
    //     row.updateLoading = false;
    //   })
    // },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '备注') {
        Dialog.open({
          title: '用户备注',
          component: UserRemarkDialog,
          data: {
            id: row.id,
            width: '1100px'
          },
          close: () => {
            row['userRemarkList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      // //充值记录
      // if(column.label == '充值记录') {
      //   Dialog.open({
      //     title: '充值记录',
      //     component: payListDialog,
      //     data: {
      //       id: row.id,
      //       userForm: row,
      //       width: '1100px'
      //     },
      //     close: () => {
      //       if(JSON.parse(sessionStorage.getItem('recordState'))) {
      //         this.getPage()
      //       }
      //       sessionStorage.removeItem('recordState')
      //     }
      //   })
      // }
      //
      // //充值记录
      // if(column.label == '抵扣记录') {
      //   Dialog.open({
      //     title: '抵扣记录',
      //     component: DeductionListDialog,
      //     data: {
      //       id: row.id,
      //       userForm: row,
      //       width: '1100px'
      //     },
      //     close: () => {
      //       if(JSON.parse(sessionStorage.getItem('recordState'))) {
      //         this.getPage()
      //       }
      //       sessionStorage.removeItem('recordState')
      //     }
      //   })
      // }

      //充值记录
      if(column.label == '充值抵扣记录') {
        Dialog.open({
          title: '充值抵扣记录',
          component: PayDeductionListDialog,
          data: {
            id: row.id,
            userForm: row,
            width: '1300px'
          },
          close: () => {
            if(JSON.parse(sessionStorage.getItem('recordState'))) {
              this.getPage()
            }
            sessionStorage.removeItem('recordState')
          }
        })
      }

      //充值总额
      if(column.label == '充值总额') {
        Dialog.open({
          title: '',
          component: WalletDialog,
          data: {
            userWallet: row.userWallet,
            type: 1,
            width: '900px'
          },
        })
      }

      //抵扣总额
      if(column.label == '抵扣总额') {
        Dialog.open({
          title: '',
          component: WalletDialog,
          data: {
            userWallet: row.userWallet,
            type: 2,
            width: '900px'
          },
        })
      }

      //总余额
      if(column.label == '总余额') {
        Dialog.open({
          title: '',
          component: WalletDialog,
          data: {
            userWallet: row.userWallet,
            type: 3,
            width: '900px'
          },
        })
      }

      //医疗金余额
      if(column.label == '医疗金余额') {
        Dialog.open({
          title: '医疗金余额',
          component: medicalListDialog,
          data: {
            userId: row.id,
            width: '1100px'
          },
          close: () => {
            if(JSON.parse(sessionStorage.getItem('recordState'))) {
              this.getPage()
            }
            sessionStorage.removeItem('recordState')
          }
        })
      }

      //消费单
      if(column.label == '消费单') {
        let userForm = Object.assign({}, row);
        Dialog.open({
          title: '消费单',
          component: ConsumeListDialog,
          data: {
            id: row.id,
            width: '1200px',
            userForm: userForm,
            shopIdArray: this.shopIdArray,
          },
          close: () => {
            if(JSON.parse(sessionStorage.getItem('recordState'))) {
              this.getPage()
            }
            sessionStorage.removeItem('recordState')
          }
        })
      }

    },


    //搜索
    openDialog() {
      // console.log(e)
      let userForm = {}
      let walletDetail = {}
      Dialog.open({
        title: '',
        component: SearchInfoDialog,
        data: {
          userForm: userForm,
          walletDetail: walletDetail,
          showSearch: true,
          width: '700px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    // let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
